import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { PATHS } from "../../constant";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getUserOtp } from "../../actions/userManagement.action";
import { getLocalstorage } from "../../helper";
import { get } from "lodash";
import { toast } from "react-toastify";
import { successToastStyle, errorToastStyle } from "../../customToast";

class GetOtp extends Component {
  onsubmit = async () => {
    let { getChangePasswordOtp } = this.props;
    try {
      const otpResult = await getChangePasswordOtp();
      toast.success(
        <p className="toast-text-alignment">
          {get(otpResult, "message", "NA")}
        </p>,
        successToastStyle
      );
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">{get("Error")}</p>,
        errorToastStyle
      );
    }
  };

  render() {
    const user = getLocalstorage("user");

    return (
      <div className="d-flex justify-content-center user-getOtp-container">
        <div className="change-otp-form m-0">
          <div className="otp-modal">
            <h3>Change Password</h3>
          </div>
          <div className="change-password-form-container">
            <div className="user-email">
              <text>You’ll be sent an OTP on your registered </text>
              email ID:{" "}
              <text className="email-text"> {get(user, "email", null)} </text>
              <text>for changing the password</text>
            </div>
            <div className="opt-button d-flex justify-content-center">
              <Link
                to={{
                  pathname: PATHS.CHANGE_PASSWORD
                }}
              >
                <Button
                  variant="primary"
                  type="button"
                  className="btn-orange"
                  onClick={this.onsubmit}
                >
                  Get OTP
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getChangePasswordOtp: getUserOtp
    },
    dispatch
  );
}

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(GetOtp)
);
